import { useNavigate } from "react-router-dom";

import PageHeader from "../../../components/ui/pageHeader/PageHeader";
import PageCard from "../../../components/ui/pageCard/PageCard";
import OrganizationForm from "../../../components/organizations/OrganizationForm";

export default function CreateOrganizationPage() {
  const navigate = useNavigate();

  return (
    <div className="organizations-page">
      <PageHeader
        eyebrow="POWER"
        title="Nieuwe organisatie"
        description="Maak een nieuwe organisatie aan."
      />

      <PageCard>
        <OrganizationForm
          mode="create"
          onSuccess={() => navigate("/dashboard/organizations")}
          onCancel={() => navigate("/dashboard/organizations")}
        />
      </PageCard>
    </div>
  );
}
